import { inject, Injectable } from '@angular/core';
import { ApiDataAccess, ResponseResult } from '@softline/core';
import { TimestampCode } from '../data/timestamp-code.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SOFTLINE_API_TIMESTAMP_CODE } from '../stempelerfassung.api';

@Injectable()
export class TimestampCodeService {
  readonly #dataAccess = inject(ApiDataAccess);

  retrieveCodes(type: TimestampCode['flag']): Observable<TimestampCode[]> {
    return this.#dataAccess
      .get$<ResponseResult<TimestampCode[]>>({
        path: SOFTLINE_API_TIMESTAMP_CODE,
        queryParams: {
          type: type === 'arrival' ? 'K' : 'G',
        },
      })
      .pipe(map((response) => response?.result ?? []));
  }
}
